import { render, staticRenderFns } from "./ThePersonalAddresses.vue?vue&type=template&id=2c34227e&"
import script from "./ThePersonalAddresses.vue?vue&type=script&lang=js&"
export * from "./ThePersonalAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalAddresses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports